import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { To } from "react-router-dom";
import { Link } from "react-router-dom";

type SectionLayoutProps = {
  title: ReactNode;
  hasSeeAll: boolean;
  children: ReactNode;
  to: To;
  count?: number;
};

const SectionLayout = ({
  title,
  hasSeeAll,
  to,
  children,
  count,
}: SectionLayoutProps) => {
  const { t: translate } = useTranslation("translation");

  return (
    <section>
      <div className="mb-8 flex justify-between px-5">
        <h2 className="text-3xl font-semibold text-foreground/80">{title}</h2>
        {hasSeeAll && (
          <Link
            className="font-semibold text-primary underline underline-offset-4"
            to={to}
          >
            {translate("see_all")} {count !== undefined && `(${count})`}
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {children}
      </div>
    </section>
  );
};

export default SectionLayout;
